/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import {CorsAnywhere} from "../CorsAnywhere";
import React from 'react'

/* global WorldWind */

export default class EcmwfPM25 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Fine Particulate matter (PM2.5)",
            service: CorsAnywhere + "http://apps.ecmwf.int/wms/&token=public",
            version: "1.3.0",
            layerNames: "composition_pm2p5",
        };

        super(cfg);

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "© ECMWF",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>Beyond gaseous pollution, atmosphere can be polluted by tiny particles of 2.5 micrometers diameter or
                less (fine particles). PM 2.5 is produced from combustion: fireplaces, car engines, and coal- or natural
                gas–fired power plants are all major PM 2.5 sources. From the map view you can see contaminated areas in
                India with PM2.5 such Dehli area, Bathinda and nearby areas. Particle matter aggregates together and
                forms ghostly haze over polluted urban areas. 2.5PM are more dangerous than PM10. Due to their small
                size they can penetrate respiratory system, get into the lungs and then into the blood stream.
            </p>
            <p><a href="http://www.irceline.be/en/documentation/faq/what-is-pm10-and-pm2.5" target="_blank"
                  rel="noopener noreferrer">Read
                more
                here.</a></p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                <img
                    src={"https://apps.ecmwf.int/wms/?token=public&request=GetLegend&layers=composition_pm10&styles=sh_nipy_spectral_ch4_surface&width=350&height=50"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                μg/m³ (microgram per cubic metre)
            </p>
        </div>);
    }
}
